module.exports = __webpack_public_path__ + "static/high-performance-fall-d625a7624e6549750af1e8129947b366.svg";